var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3971 18.0002C20.3971 19.0874 19.5157 19.9688 18.4285 19.9688C17.3413 19.9688 16.46 19.0874 16.46 18.0002C16.46 16.913 17.3413 16.0316 18.4285 16.0316C19.5157 16.0316 20.3971 16.913 20.3971 18.0002Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4285 22.2028H18.4291C19.5432 22.2016 20.6114 21.7584 21.3992 20.9706C22.187 20.1828 22.6301 19.1147 22.6314 18.0006V18C22.6314 17.1687 22.3849 16.3562 21.9231 15.665C21.4613 14.9739 20.8049 14.4352 20.0369 14.1171C19.2689 13.799 18.4239 13.7157 17.6086 13.8779C16.7933 14.0401 16.0444 14.4403 15.4567 15.0281C14.8689 15.6159 14.4686 16.3648 14.3064 17.1801C14.1443 17.9953 14.2275 18.8404 14.5456 19.6084C14.8637 20.3763 15.4024 21.0327 16.0935 21.4945C16.7847 21.9564 17.5973 22.2028 18.4285 22.2028ZM15.0345 10.7857H21.8225C22.8353 10.7869 23.8063 11.1898 24.5225 11.906C25.2388 12.6222 25.6417 13.5933 25.6428 14.6063V21.3937C25.6417 22.4066 25.2388 23.3777 24.5225 24.094C23.8063 24.8102 22.8352 25.2131 21.8222 25.2143H15.0348C14.0219 25.2131 13.0508 24.8102 12.3345 24.094C11.6183 23.3778 11.2155 22.4068 11.2142 21.394V14.606C11.2155 13.5932 11.6183 12.6222 12.3345 11.906C13.0507 11.1898 14.0217 10.7869 15.0345 10.7857ZM23.6254 13.1965L23.2097 13.4743L23.6254 13.1965C23.4687 12.962 23.2461 12.7793 22.9855 12.6714C22.725 12.5635 22.4384 12.5352 22.1618 12.5902C21.8852 12.6453 21.6312 12.781 21.4318 12.9804C21.2324 13.1798 21.0966 13.4339 21.0416 13.7104C20.9866 13.987 21.0149 14.2736 21.1228 14.5342C21.2307 14.7947 21.4134 15.0173 21.6479 15.174C21.8823 15.3307 22.158 15.4143 22.4399 15.4143C22.8181 15.4143 23.1807 15.2641 23.4481 14.9967C23.7155 14.7293 23.8657 14.3667 23.8657 13.9886C23.8657 13.7066 23.782 13.4309 23.6254 13.1965Z",
    fill: "#F0F0F0",
    stroke: "#F0F0F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    stroke: "#F0F0F0",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.48c2a74dca1eea202d3e5d2329c8d172.svg";
export { ForwardRef as ReactComponent };